export default __webpack_public_path__ + "static/media/thesisbutton.d8514b46.PNG";